@if (label(); as text) {
  <div class="form-field__aside">
    @if (controlId(); as id) {
      <label class="form-field__label" [for]="id">{{ text }}</label>
    } @else {
      <span class="form-field__label">{{ text }}</span>
    }

    @if (hint(); as hintText) {
      <p class="form-field__hint">{{ hintText }}</p>
    }
  </div>
}

<div class="form-field__body">
  <ng-content />

  @if (showErrorIcon()) {
    <app-icon class="form-field__error-icon" name="alert-circle" />
  }

  @if (message(); as text) {
    <p class="form-field__error" role="alert">{{ text }}</p>
  }
</div>
